import React from 'react';
import { Handle, Position } from 'reactflow';
import { DatabaseOutlined } from '@ant-design/icons';

const DataSourceNode = ({ data, selected }) => {
  // console.log('DataSourceNode; ', data.config)
  // Check if the data source is configured
  // For CSV files, only connectionId is required (no table/dataset needed)
  const isConfigured = data.config?.connectionId && 
    (data.config?.sourceType === 'csv' || data.config?.table || data.config?.dataset || data.config?.sourceType);
  
  // Determine colors based on configuration status
  const nodeColor = isConfigured ? '#52c41a' : '#d9d9d9';
  const iconColor = isConfigured ? '#52c41a' : '#999';
  const textColor = isConfigured ? '#333' : '#999';
  
  // Get display names
  const getDisplayName = () => {
    if (data.config?.connectionName) {
      return data.config.connectionName;
    }
    return isConfigured ? 'Configured Data Source' : 'Data Source';
  };
  
  const getDatasetInfo = () => {
    if (data.config?.table) {
      return `Sheet: ${data.config.table}`;
    }
    if (data.config?.dataset) {
      return `Dataset: ${data.config.dataset}`;
    }
    return isConfigured ? 'Configured' : 'Not configured';
  };

  return (
    <div className={`react-flow__node-dataSource ${selected ? 'selected' : ''}`}
         style={{
           borderColor: nodeColor,
           backgroundColor: isConfigured ? 'white' : '#f5f5f5',
           opacity: isConfigured ? 1 : 0.7
         }}>
      {/* Target handle for incoming connections from start node */}
      <Handle
        type="target"
        position={Position.Left}
        style={{
          background: nodeColor,
          border: '2px solid #fff',
          width: '8px',
          height: '8px'
        }}
      />
      
      <div style={{ 
        padding: '12px', 
        display: 'flex', 
        alignItems: 'center', 
        gap: '8px',
        minWidth: '140px'
      }}>
        <DatabaseOutlined style={{ fontSize: '16px', color: iconColor }} />
        <div>
          <div style={{ 
            fontWeight: '500', 
            fontSize: '13px',
            color: textColor
          }}>
            {getDisplayName()}
          </div>
          <div style={{ 
            fontSize: '11px', 
            color: isConfigured ? '#666' : '#999',
            fontStyle: isConfigured ? 'normal' : 'italic'
          }}>
            {getDatasetInfo()}
          </div>
        </div>
      </div>
      
      {/* Source handle for outgoing connections to other nodes */}
      <Handle
        type="source"
        position={Position.Right}
        style={{
          background: nodeColor,
          border: '2px solid #fff',
          width: '8px',
          height: '8px'
        }}
      />
    </div>
  );
};

export default DataSourceNode;